import { ContextMenuOptionsService } from '../3d/misc-services/context-menu-options.service';
// eslint-disable-next-line import-whitelist -- ok in this case
import { AbstractResource } from '../core/http/abstract-resource';
import { MouseEventService } from './misc-services/events/mouse-event.service';
import { KeyboardShortcutService } from './misc-services/keyboard-shortcut.service';

export const contentProviders = [
  AbstractResource,
  ContextMenuOptionsService,
  KeyboardShortcutService,
  MouseEventService,
];
